import type { HTMLComponent } from "@commercekit/react";
import classNames from "classnames";
import { useField } from "remix-validated-form";
import { usePrismicLabels } from "~/hooks/usePrismicLabel";

const WvField: HTMLComponent<{
  name: string;
  required?: boolean;
  customError?: string;
  fieldClass?: string;
  label: string;
  passwordStrength?: string;
  noMarginBottom?: boolean;
}> = ({
  name,
  label,
  required,
  children,
  customError,
  fieldClass,
  passwordStrength,
  noMarginBottom,
  ...props
}) => {
  const { $pt } = usePrismicLabels();
  const { error } = useField(name);
  return (
    <div className={classNames("relative z-0", fieldClass, { "mb-3": !noMarginBottom })} {...props}>
      <div className={`input ${label ? "input--label" : ""}`}>
        {children}
        <label htmlFor={name} className="input__label">
          {$pt(label)} {required ? "*" : ""}
        </label>
        {passwordStrength ? (
          <div
            className="customer__password"
            data-password-strength={passwordStrength}
          ></div>
        ) : null}
        {error || customError ? (
          <span className="error-label" style={{ marginTop: "-3px" }}>
            {$pt(error ?? customError ?? "")}
          </span>
        ) : null}
      </div>
    </div>
  );
};
export default WvField;
